import {
	CardBody,
	CardFooter,
	CardHeader,
	CardHeading,
	I18nDiscardLocaleButton,
	I18nErrorToast,
	I18nFormProvider,
	I18nLocaleSwitcher,
	SubmitButton,
	validateEachLanguage,
} from "@dgs/core";
import { Form, Formik } from "formik";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ProductTranslationField } from "../productTranslations/ProductTranslationField";
import { ProductTranslationEntry, ProductTranslationFormValues } from "../shared/types/productTranslation";

interface Props {
	translations: ProductTranslationFormValues;
	handleSave: (settings: ProductTranslationFormValues) => Promise<void>;
}

const emptyProductTranslationEntry: ProductTranslationEntry = {
	value: "{}",
};

const isValidJson = (json: string): boolean => {
	try {
		if (json) {
			JSON.parse(json);
		}
	} catch {
		return false;
	}

	return true;
};

export const ProductTranslationsForm: FC<Props> = ({ translations, handleSave }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: ProductTranslationFormValues) => {
			const errors: Record<string, any> = {};

			return {
				...validateEachLanguage(values.translations, (language, values) => {
					if (!values.value) {
						errors.value = t("Field is required");
					} else if (!isValidJson(values.value)) {
						errors.value = t("You need to enter valid JSON.");
					}
					return errors;
				}),
			};
		},
		[t],
	);

	return (
		<I18nFormProvider>
			<Formik initialValues={translations} validate={validate} onSubmit={handleSave}>
				<Form>
					<CardHeader>
						<CardHeading>{t("Edit product translations")}</CardHeading>
						<I18nLocaleSwitcher emptyTranslation={emptyProductTranslationEntry} />
					</CardHeader>
					<CardBody>
						<ProductTranslationField />
					</CardBody>
					<CardFooter>
						<I18nDiscardLocaleButton />
						<SubmitButton title={t("Save")} name={t("Save")}>
							{t("Save")}
						</SubmitButton>
					</CardFooter>
					<I18nErrorToast />
				</Form>
			</Formik>
		</I18nFormProvider>
	);
};
